import { Antrag } from '../../types';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currentSizeInByte',
  standalone: true,
})
export class CurrentSizeInBytePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public transform(antrag: Antrag, antragPagesToEnforceChangeDetection: number): Promise<number> {
    return antrag.getSizeInBytes();
  }
}
